<template>
  <div class="mainPage">
    <header class="header">
      <div class="top">
        <div class="left">
          <span><img src="../assets/calogo.png" alt="" /></span>
          <div class="pingtai">统一电子认证电子印章管理平台</div>
        </div>
        <div class="right">
          <!-- <el-button
            type="primary"
            size="mini"
            v-if="applySealed"
            @click="$router.push('/applySeal') && this.userInfo"
            ><i class="iconfont icon-yinzhangguanli"></i> 申领印章</el-button
          > -->
          <div class="loginOrRegist" v-if="IS_LOGIN">
            <span class="regist" @click="toRegist">注册</span> /
            <span class="loginmethods" @click="toLogin">登录</span>
          </div>

          <el-dropdown @command="handleCommand" v-else>
            <span class="el-dropdown-link">
              {{
                this.userInfo.LEGAL_PERSON
                  ? this.userInfo.LEGAL_PERSON
                  : userName
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                command="a"
                @click.native="$router.push('/main/log/management')"
                >用户中心</el-dropdown-item
              >
              <el-dropdown-item command="a" @click.native="loginOut"
                >安全退出</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div id="nav">
        <nav class="navbar">
          <navbar></navbar>
        </nav>
      </div>
    </header>
    <main class="main" ref="main">
      <!-- <div style="minHeight: 713px; overflow: hidden"> -->
      <div class="div_box">
        <router-view></router-view>
        <div class="companyInfo">
          <div class="contentUS">
            <div class="topOne">联系我们</div>
            <div class="toptow">
              <i class="iconfont icon-dizhi"></i>
              地址：河南省郑州市明理路平安大道博雅广场4号楼
            </div>
            <div class="toptow">
              <i class="iconfont icon-dianhua"></i>技术支持电话：0371-96596
            </div>
          </div>
          <div class="aboutUs">
            <div class="topOne">相关链接</div>
            <div class="toptow link" @click="toCompany">
              河南省信息化集团有限公司
            </div>
            <div class="toptow link" @click="toPri">河南省政务服务网</div>
          </div>
          <div class="downLoadApp">
            <div class="topOne">APP下载</div>
            <div class="downLoad">
              <div class="topthree">
                <div class="threespan">安卓</div>
                <el-image
                  style="width: 65px; height: 65px"
                  :src="url"
                  :preview-src-list="srcList"
                >
                </el-image>
              </div>
              <!-- <div style="width: 100%; text-align: center">敬请期待</div> -->
            </div>
          </div>
        </div>
      </div>
    </main>

    <footer class="fotter">
      版权所有：河南省信息化集团有限公司
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a
        href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
        target="_blank"
        >备案：豫ICP备14012421号-6</a
      >
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <!-- 版权所有：河南省信息化发展有限公司 -->
    </footer>
  </div>
</template>

<script>
import navbar from "@/components/navbar";
export default {
  name: "Main",
  components: {
    navbar,
  },
  data() {
    return {
      msg: "",
      IS_LOGIN: true,
      userName: "",
      applySealed: true,
      userInfo: "",
      url: require("../assets/app.jpg"),
      srcList: [require("../assets/app.jpg")],
    };
  },
  methods: {
    //去应用服务
    toApplication() {
      // document.querySelector('#color_white').scrollIntoView(true)
      // var auchor = this.$refs.main
      // document.body.scrollTop=auchor.offsetTop
    },
    //去注册
    toRegist() {
      this.$router.push("/regist");
    },
    //去登录
    toLogin() {
      this.$router.push("/login");
    },

    handleCommand() {},
    //退出登录
    loginOut() {
      this.$http.post("/login/logOut.shtml").then((res) => {
        if (res.data.code == 0) {
          sessionStorage.clear();
          this.$router.push("/main");
          this.$message.success("退出登录成功");
          this.IS_LOGIN = true;

          // window.location.reload();
        } else {
          this.$router.push("/login");
        }
      });
    },
    //跳转公司
    toCompany() {
      window.open("https://www.hnxaca.com/");
    },
    //政务服务
    toPri() {
      window.open(" https://www.hnzwfw.gov.cn/");
    },
    //查询印章申请状态 /pcApplyInfo/applyCheck.shtml
    saveApply() {
      let param = {
        userId: sessionStorage.getItem("userId")
          ? sessionStorage.getItem("userId")
          : "-1",
      };
      this.$http.post("/pcApplyInfo/applyCheck.shtml", param).then((res) => {
        let { code, msg, applyStatus } = res.data;
        if (code == 0) {
          sessionStorage.setItem("applyStatus", applyStatus);
          this.applyStatus = applyStatus;
          if (applyStatus == 0 || applyStatus == 4) {
            this.applySealed = true;
          } else {
            this.applySealed = false;
          }
        } else {
          this.$message.error(msg);
        }
      });
    },
  },
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (!sessionStorage.getItem("userName")) {
      this.IS_LOGIN = true;
      this.applySealed = false;
    } else {
      this.userName = sessionStorage.getItem("userName");
      this.IS_LOGIN = false;
      this.saveApply();
      this.applySealed = true;
    }
  },
  created() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iconfont {
  display: inline-block;
}
.mainPage {
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: #ffffff;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.header {
  width: 100%;
  height: 0.101652%vh;
  background-color: #ffffff;
  position: fixed;
  z-index: 999;
}
.top {
  width: 1110px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left {
  font-family: MicrosoftYaHei-Bold;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #333333;
  display: flex;
}
.pingtai {
  margin-left: 8px;
  line-height: 108px;
}
.right {
  display: flex;
  font-size: 18px;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #666666;
}
.el-dropdown-link {
  cursor: pointer;
}
.right > button {
  margin-right: 21px;
}
.shu {
  height: 18px;
  width: 1px;
  color: #666666;
  padding: 0 20px;
}
span > img {
  height: 70px;
  width: 94px;
  margin-top: 25px;
}
.main {
  /* position: absolute; */
  margin-top: 188px;
  color: #333;
  min-height: 80.2vh;
  width: 100%;
  position: relative;
  bottom: 36px;
  overflow: auto; /*超出的部分，滚动条显示*/
}
.div_box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 750px;
}
.regist {
  cursor: pointer;
}
.loginmethods {
  cursor: pointer;
}
#nav {
  height: 44px;
  background-color: #2850a0;
}
.navbar {
  width: 1110px;
  margin: 0 auto;
  height: 44px;
}
.router {
  text-decoration: none;
  color: #ffffff;
  line-height: 44px;
  width: 140px;
  display: inline-block;
  text-align: center;
}
.router:hover {
  background-color: #173c87;
}
.companyInfo {
  display: flex;
  justify-content: space-between;
  width: 1110px;
  margin: 0 auto;
  /* margin-top: 29px;
  margin-bottom: 2px; */
  /* margin-bottom: 48px; */
}
.contentUS {
  width: 400px;
  height: 110px;
  background-color: #f5f5f5;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}
.aboutUs {
  width: 368px;
  height: 110px;
  background-color: #f5f5f5;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}
.downLoadApp {
  width: 296px;
  height: 110px;
  background-color: #f5f5f5;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}
.downLoad {
  display: flex;
}
.topOne {
  margin: 10px 0px 14px 10px;
}
.toptow {
  margin: 10px 0px 16px 10px;
  height: 22px;
  cursor: pointer;
}
.topthree {
  display: flex;
  width: 113px;
  margin: auto 65px;
  /* overflow: hidden; */
}
.threespan {
  margin: 23px 8px 0px 10px;
  width: 30px;
  height: 16px;
}
.fotter {
  height: 36px;
  background-color: #cccccc;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
  line-height: 36px;
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  z-index: 999;
}
/* a{
  color: #333333;
  text-decoration: none;
} */
.toptow {
  display: flex;
}
.iconfont {
  display: inline;
}
.el-link {
  width: 120px;
  height: 44px;
  /* display: inline-block; */
  color: #fdb5b5;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/main/Main.vue